import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { TemplateServices } from '../services/templateServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';

const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
);

const items = [
    { id: 1, "title": "Template1","text": "<h1><strong>Lorem ipsum</strong></h1><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas sed tempus. Placerat vestibulum lectus mauris ultrices eros in cursus. Amet massa vitae tortor condimentum. Vitae justo eget magna fermentum iaculis eu non diam phasellus. Nam aliquam sem et tortor consequat id porta. Sapien et ligula ullamcorper malesuada proin libero. Massa id neque aliquam vestibulum morbi. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam. Tincidunt tortor aliquam nulla facilisi cras fermentum odio eu. Eu facilisis sed odio morbi. Erat nam at lectus urna duis convallis convallis. Viverra accumsan in nisl nisi. Adipiscing diam donec adipiscing tristique risus nec. Ultrices mi tempus imperdiet nulla. Praesent elementum facilisis leo vel fringilla est. Dui nunc mattis enim ut tellus.</p><p><br></p><p>Nibh venenatis cras sed felis eget velit. Lorem sed risus ultricies tristique nulla aliquet enim tortor. In tellus integer feugiat scelerisque varius morbi enim. Sem integer vitae justo eget magna. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Pharetra diam sit amet nisl. Varius vel pharetra vel turpis. Sit amet mattis vulputate enim nulla. At erat pellentesque adipiscing commodo. Lectus vestibulum mattis ullamcorper velit sed ullamcorper. Ultricies mi eget mauris pharetra et ultrices. Amet tellus cras adipiscing enim eu turpis egestas pretium aenean. Eu nisl nunc mi ipsum faucibus. Eleifend quam adipiscing vitae proin sagittis nisl. Pretium vulputate sapien nec sagittis aliquam malesuada. Quisque sagittis purus sit amet volutpat. Arcu cursus euismod quis viverra nibh. Et pharetra pharetra massa massa.</p>"},
    { id: 2, "title": "Template2", "text": "<h1><strong>Lorem ipsum 2</strong></h1><p><br></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas sed tempus. Placerat vestibulum lectus mauris ultrices eros in cursus. Amet massa vitae tortor condimentum. Vitae justo eget magna fermentum iaculis eu non diam phasellus. Nam aliquam sem et tortor consequat id porta. Sapien et ligula ullamcorper malesuada proin libero. Massa id neque aliquam vestibulum morbi. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam. Tincidunt tortor aliquam nulla facilisi cras fermentum odio eu. Eu facilisis sed odio morbi. Erat nam at lectus urna duis convallis convallis. Viverra accumsan in nisl nisi. Adipiscing diam donec adipiscing tristique risus nec. Ultrices mi tempus imperdiet nulla. Praesent elementum facilisis leo vel fringilla est. Dui nunc mattis enim ut tellus.</p><p><br></p><p>Nibh venenatis cras sed felis eget velit. Lorem sed risus ultricies tristique nulla aliquet enim tortor. In tellus integer feugiat scelerisque varius morbi enim. Sem integer vitae justo eget magna. Ut morbi tincidunt augue interdum velit euismod in pellentesque massa. Pharetra diam sit amet nisl. Varius vel pharetra vel turpis. Sit amet mattis vulputate enim nulla. At erat pellentesque adipiscing commodo. Lectus vestibulum mattis ullamcorper velit sed ullamcorper. Ultricies mi eget mauris pharetra et ultrices. Amet tellus cras adipiscing enim eu turpis egestas pretium aenean. Eu nisl nunc mi ipsum faucibus. Eleifend quam adipiscing vitae proin sagittis nisl. Pretium vulputate sapien nec sagittis aliquam malesuada. Quisque sagittis purus sit amet volutpat. Arcu cursus euismod quis viverra nibh. Et pharetra pharetra massa massa.</p>" },
];

export default class EmailTemplatesStore {    

    
  rootStore;
  templates = [];
    template = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,


          templates: observable,
          template: observable,
          getAll: action,
          //get:action,
          reset: action,
          save: action,
          remove: action,
          duplicate: action,
          send:action
      });
      makePersistable(this, { name: 'emailTemplatesStore', properties: ['config'], storage: window.localStorage });

    }       

    remove = async (id) => {
        try {
            const data = await TemplateServices.delete(id);
            runInAction(() => {toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("template") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    duplicate = async (id) => {
        try {
            const data = await TemplateServices.duplicate(id);
            runInAction(() => { toast.success(`${i18n.t("wasDuplicated", { entity: i18n.t("template") })}`); });
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/ });
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await TemplateServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("template") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await TemplateServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("template") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.template = {});
    }
    
    /*get = async (id) => {
        runInAction(() => {
            this.template = items.filter(x => x.id == id)[0] || null;
        });
    }*/

    setConfig = (prop, c) => { this.config[prop] = c; }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await TemplateServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.templates = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.templates = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await TemplateServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => {this.templates = data;})
        }
        catch (error) {
            runInAction(() => {this.templates = [];});
        }
    }    

    getById = async (id) => {
        try {
            const data = await TemplateServices.getById(id);
            runInAction(() => { this.template = data;});
        } catch (error) {
            runInAction(() => { this.template = {};})
        }
    };

    send = async (dto) => {
        try {
            const data = await TemplateServices.send(dto);
            runInAction(() => { toast.success(i18n.t("messageSent")) });
        } catch (error) {
            runInAction(() => { })
        }
    }
}